import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // width: '100%',
    // height: '70vh',
    height: '100%',
    gap: '0.75rem',
    '& > p': {
      fontSize: '1.65rem',
      textAlign: 'center',
    },
  },
}))

export default styles
